import React from "react";
import TapsiBubbles from "./TapsiBubbles";

export default function MiniGames() {
  return (
    <div className="container minigames-page">
      <div className="section-title-row">
        <h1 className="games-title">Games</h1>
      </div>
      <TapsiBubbles />
    </div>
  );
}
